import { ResetPassword } from 'src/sections/auth';

// ----------------------------------------------------------------------

export default function ResetPasswordPage() {
  return (
    <ResetPassword />
  );
}
